module.exports = __webpack_public_path__ + "img/EyeLab_Logo1.cd293e31.jpg";